import { z } from 'zod';

export const MaterialSchema = z.object({
  id: z.number().int(),
  code: z.string(),
  label: z.string(),
});

export const WindowTypeSchema = z.object({
  id: z.number().int(),
  code: z.string(),
  label: z.string(),
});

export const SeriesSchema = z.object({
  id: z.number().int(),
  label: z.string(),
});

export const SashSchema = z.object({
  id: z.number().int(),
  label: z.string(),
});

export const TypeSchema = z.object({
  id: z.number().int(),
  label: z.string(),
});

export const CombinationComponentSchema = z.object({
  id: z.number().int(),
  combinationId: z.number().int(),
  componentId: z.number().int(),
  displayOrder: z.number().int(),
  labelOverride: z.string().nullable().optional(),
  code: z.string(),
  label: z.string(),
});

export const CombinationInputFieldBindingSchema = z.object({
  id: z.number().int(),
  combinationId: z.number().int(),
  inputFieldId: z.number().int(),
  isRequired: z.number().int(), // 0 or 1
  labelOverride: z.string().nullable().optional(),
  displayOrder: z.number().int(),
  code: z.string(),
  label: z.string(),
  dataType: z.string(),
  isDimension: z.number().int(),
});

export type MaterialDto = z.infer<typeof MaterialSchema>;
export type WindowTypeDto = z.infer<typeof WindowTypeSchema>;
export type SashDto = z.infer<typeof SashSchema>;
export type CombinationComponentDto = z.infer<typeof CombinationComponentSchema>;
export type CombinationInputFieldBindingDto = z.infer<typeof CombinationInputFieldBindingSchema>;

export const CombinationCalculationSchema = z.object({
  id: z.number().int(),
  combinationId: z.number().int(),
  targetComponentId: z.number().int(),
  targetAxis: z.string(),
  sequence: z.number().int(),
  sourceKind: z.string(),
  sourceComponentId: z.number().int().nullable().optional(),
  sourceAxis: z.string().nullable().optional(),
  sourceInputFieldId: z.number().int().nullable().optional(),
  operator: z.string(),
  operandValue: z.number().nullable().optional(),
  targetComponentCode: z.string(),
});

export type CombinationCalculationDto = z.infer<typeof CombinationCalculationSchema>;

export const WindowCombinationDtoSchema = z.object({
  id: z.number().int(),
  tenantId: z.number().int(),
  materialId: z.number().int(),
  windowTypeId: z.number().int(),
  seriesId: z.number().int(),
  typeId: z.number().int(),
  sashId: z.number().int().nullable().optional(),
  frameStyle: z.string().nullable().optional(),
  isSupported: z.number().int(),
  components: z.array(CombinationComponentSchema),
  inputBindings: z.array(CombinationInputFieldBindingSchema),
  calculations: z.array(CombinationCalculationSchema),
});

export type WindowCombinationDto = z.infer<typeof WindowCombinationDtoSchema>;
